var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAttachFile = function SvgIconAttachFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.5,
    height: 15,
    viewBox: "0 0 7.5 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.977,4.909V12.75a2.727,2.727,0,0,1-5.455,0V4.227a1.7,1.7,0,1,1,3.409,0v7.159a.682.682,0,0,1-1.364,0V4.909H12.545v6.477a1.7,1.7,0,0,0,3.409,0V4.227a2.727,2.727,0,1,0-5.455,0V12.75a3.75,3.75,0,0,0,7.5,0V4.909Z",
    transform: "translate(-10.5 -1.5)",
    fill: "#8d8585"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAttachFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-attach-file.6b6962fc.svg";
export { ForwardRef as ReactComponent };